import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { colors } from "../ui/colors";

export const WidgetEmployee = ({
  swapyName,
  sxProp,
  children,
  refResizeObserver,
  ...props
}) => {
  return (
    <Box
      data-swapy-slot={swapyName}
      sx={{
        backgroundColor: "#e0e0e0",
        borderRadius: 5,
        height: "100%",      
        width: "100%",       
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        data-swapy-item={swapyName}
        {...props}
        ref={refResizeObserver}
        component={motion.div}
        sx={{
          cursor: "grab",
          border: `1.5px solid ${colors.warmWhite.strong}`,
          padding: "12px",
          borderRadius: "16px",
          bgcolor: "var(--fx-surface-base, #FFFFFF)",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          height: "100%",
          width: "100%",
          ...sxProp,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

